import { Grid } from "@material-ui/core";
import { FunctionComponent } from "react";
import styled from "styled-components";
import { Button } from "../../../components/button";
import { useCopying } from "../../../components/hooks/use-copying";
import { Icon } from "../../../components/icons";
import { FlexedGridItem } from "../../kyc-kyb-aml/components";

const StyledButton = styled(Button)`
  margin-left: 1em;
`;

export const PasswordGeneratedModal: FunctionComponent<{
  generatedPassword: string;
}> = ({ generatedPassword }) => {
  const [isCopying, setCopying] = useCopying(generatedPassword);

  return (
    <Grid container spacing={3}>
      <FlexedGridItem spaceBetween xs={12}>
        {generatedPassword}
        <StyledButton onClick={() => setCopying()} disabled={isCopying}>
          <Icon type="copy" />
        </StyledButton>
      </FlexedGridItem>
    </Grid>
  );
};
